import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {SpinnerComponent} from "./spinner.component";

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
  ],
  declarations: [SpinnerComponent],
  exports: [SpinnerComponent]
})
export class SpinnerModule { }
